import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FlagIcon from '@material-ui/icons/Flag';
import StoreIcon from '@material-ui/icons/Store';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PaymentIcon from '@material-ui/icons/Payment';
import { Link } from 'react-router-dom';

import VortexBlackLogo from '../assets/vortex_logo_black.png';

// import Country1Image from 'https://www.countryflags.com/wp-content/uploads/philippines-flag-png-large.png';
// import Country2Image from 'https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png';
// import Country3Image from 'https://www.countryflags.com/wp-content/uploads/japan-flag-png-large.png';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    color: '#000',
  },
  formControl: {
    minWidth: 200,
    marginBottom: theme.spacing(3),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  flagIcon: {
    marginRight: theme.spacing(1),
  },
  optionImage: {
    width: '24px',
    height: '24px',
    marginRight: theme.spacing(1),
    borderRadius: '50%',
  },
}));

function getSteps() {
  return [
    { label: 'Business Start/Selling Status', icon: MonetizationOnIcon },
    { label: 'Current Selling Method', icon: PaymentIcon },
    { label: 'Additional Services', icon: StoreIcon },
    { label: 'Store Name', icon: StoreIcon },
    { label: 'Location', icon: LocationOnIcon },
  ];
}

export default function BusinessSetupStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [businessStatus, setBusinessStatus] = useState('');
  const [sellingMethod, setSellingMethod] = useState('');
  const [additionalServices, setAdditionalServices] = useState([]);
  const [storeName, setStoreName] = useState('');
  const [location, setLocation] = useState('country1');

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChangeBusinessStatus = (event) => {
    setBusinessStatus(event.target.value);
  };

  const handleChangeSellingMethod = (event) => {
    setSellingMethod(event.target.value);
  };

  const handleChangeAdditionalServices = (event) => {
    const { value } = event.target;
    if (additionalServices.includes(value)) {
      setAdditionalServices((prevServices) =>
        prevServices.filter((service) => service !== value)
      );
    } else {
      setAdditionalServices((prevServices) => [...prevServices, value]);
    }
  };

  const handleChangeStoreName = (event) => {
    setStoreName(event.target.value);
  };

  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
  };

  const handleReset = () => {
    setActiveStep(0);
    };


  const StepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <Typography variant="h6" className={classes.instructions}>
              Business Start/Selling Status
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
              Select the status that best describes your business.
            </Typography>
            <div className={classes.checkboxGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={businessStatus === 'just starting'}
                    onChange={handleChangeBusinessStatus}
                    value="just starting"
                    color="primary"
                  />
                }
                label={
                  <>
                    <MonetizationOnIcon className={classes.icon} />
                    Just Starting
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={businessStatus === 'already selling'}
                    onChange={handleChangeBusinessStatus}
                    value="already selling"
                    color="primary"
                  />
                }
                label={
                  <>
                    <MonetizationOnIcon className={classes.icon} />
                    Already Selling
                  </>
                }
              />
            </div>
          </>
        );
      case 1:
        return (
          <>
            <Typography variant="h6" className={classes.instructions}>
              Current Selling Method
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
              How do you currently sell your products or services?
            </Typography>
            <div className={classes.checkboxGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sellingMethod === 'social media'}
                    onChange={handleChangeSellingMethod}
                    value="social media"
                    color="primary"
                  />
                }
                label={
                  <>
                    <PaymentIcon className={classes.icon} />
                    Social Media
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sellingMethod === 'website'}
                    onChange={handleChangeSellingMethod}
                    value="website"
                    color="primary"
                  />
                }
                label={
                  <>
                    <PaymentIcon className={classes.icon} />
                    Website
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sellingMethod === 'physical store'}
                    onChange={handleChangeSellingMethod}
                    value="physical store"
                    color="primary"
                  />
                }
                label={
                  <>
                    <PaymentIcon className={classes.icon} />
                    Physical Store
                  </>
                }
              />
            </div>
          </>
        );
      case 2:
        return (
          <>
            <Typography variant="h6" className={classes.instructions}>
              Additional Services
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
              Select any additional services you would like to offer.
            </Typography>
            <div className={classes.checkboxGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={additionalServices.includes('bills payment')}
                    onChange={handleChangeAdditionalServices}
                    value="bills payment"
                    color="primary"
                  />
                }
                label={
                  <>
                    <img
                      src={"https://sandbox.sparkles.com.ph/static/bills-252345465819af7acc4b1c08acbf2d55.svg"}
                      alt="Bills Payment"
                      className={classes.optionImage}
                    />
                    Bills Payment
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={additionalServices.includes('load')}
                    onChange={handleChangeAdditionalServices}
                    value="load"
                    color="primary"
                  />
                }
                label={
                  <>
                    <img
                      src={"https://sandbox.sparkles.com.ph/static/load-9d89a7727840686a45bd96951e46063a.svg"}
                      alt="Load"
                      className={classes.optionImage}
                    />
                    Load
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={additionalServices.includes('e-gifts')}
                    onChange={handleChangeAdditionalServices}
                    value="e-gifts"
                    color="primary"
                  />
                }
                label={
                  <>
                    <img
                      src={"https://sandbox.sparkles.com.ph/static/voucher-c00256800423f88f7ff7f267282794d1.svg"}
                      alt="E-Gifts"
                      className={classes.optionImage}
                    />
                    E-Gifts
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={additionalServices.includes('decide later')}
                    onChange={handleChangeAdditionalServices}
                    value="decide later"
                    color="primary"
                  />
                }
                label={
                  <>
                    <img
                      src={"data:image/png;base64,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"}
                      alt="Decide Later"
                      className={classes.optionImage}
                    />
                    Decide Later
                  </>
                }
              />
            </div>
          </>
        );
      case 3:
        return (
          <>
            <Typography variant="h6" className={classes.instructions}>
              Store Name
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
              Please enter the name of your store.
            </Typography>
            <TextField
              value={storeName}
              onChange={handleChangeStoreName}
              label="Store Name"
              variant="outlined"
              fullWidth
              margin="normal"
            />
          </>
        );
      case 4:
        return (
          <>
            <Typography variant="h6" className={classes.instructions}>
              Location
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
              Where will your business be located? We'll use your location to set up your default currency rates, related policies/tax, and more.
            </Typography>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Location</InputLabel>
              <Select value={location} onChange={handleChangeLocation}>
                <MenuItem value="country1">
                  <img
                    src={"https://www.countryflags.com/wp-content/uploads/philippines-flag-png-large.png"}
                    alt="Country 1"
                    className={classes.optionImage}
                  />
                  Country 1
                </MenuItem>
                <MenuItem value="country2">
                  <img
                    src={"https://www.countryflags.com/wp-content/uploads/philippines-flag-png-large.png"}
                    alt="Country 2"
                    className={classes.optionImage}
                  />
                  Country 2
                </MenuItem>
                <MenuItem value="country3">
                  <img
                    src={"https://www.countryflags.com/wp-content/uploads/philippines-flag-png-large.png"}
                    alt="Country 3"
                    className={classes.optionImage}
                  />
                  Country 3
                </MenuItem>
              </Select>
            </FormControl>
          </>
        );
      default:
        return 'Unknown stepIndex';
    }
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              StepIconComponent={step.icon}
              classes={{
                active: classes.activeStep,
                completed: classes.completedStep,
              }}
            >
              <Typography variant="subtitle2">{step.label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        <img src={VortexBlackLogo}  height="50" alt="Logo" style={{height:"5em", textAlign:"center"}}/> 
      </div>
      <div className={classes.contentContainer}>
        {activeStep === steps.length ? (
          <div>
            <Typography variant="h6" className={classes.instructions}>
            Congratulations onboarding completed!
            </Typography>
            <Typography variant="h6" className={classes.instructions}>
            Confirm the details below and click on "Finish" to complete the onboarding process.
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
                <b>Store Name:</b> {storeName}
            </Typography>
            <Typography variant="subtitle1" className={classes.instructions}>
                <b>Location:</b> {location}
            </Typography>
           
            <Button
                // disabled={activeStep === 0}
                onClick={handleBack}
                className={classes.backButton}
                variant="contained"
                color="primary"
              >
                Back
              </Button>
              
            <Button onClick={handleReset} variant="contained" color="primary">
              Reset
            </Button>

            <Link className={classes.backButton}
                variant="contained"
                color="primary" to="/signin" style={{marginLeft:"1em"}}>
                 <Button  variant="contained" color="primary">

                  Proceed
                 </Button>
                </Link>
          </div>
        ) : (
          <div>
            {StepContent(activeStep)}
            <div>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                className={classes.backButton}
                variant="contained"
                color="primary"
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                {activeStep === steps.length - 1 ? 'Confirm Details' : 'Next'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
